import { getDateFromString } from '../../utils/dateTime';

export function transform(child) {
    return {
        ...child,
        birthDate: getDateFromString(child.birthDate),
    };
}